import BalanceHoursCorrection from "app/models/balanceHoursCorrection"
import { Action, Types } from "./balanceHoursCorrections.actions"

export type BalanceHoursCorrectionsState = {
  data: BalanceHoursCorrection[]
  errors: {}
  loading: boolean
}

const initialState: BalanceHoursCorrectionsState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): BalanceHoursCorrectionsState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
